<template>
  <div
    class="ai-search-spot"
    @click="onSearchItemClick"
  >
    <div class="ai-search-spot__header">
      <img
        class="ai-search-spot__logo"
        src="@/assets/colorIcon/ai-star.svg"
        alt="ai"
      >
      <p class="ai-search-spot__title">
        Deep Search
      </p>
    </div>
    <p class="ai-search-spot__subTitle">
      AI has found the products you may need!
    </p>
    <div class="ai-search-spot-result">
      <div class="ai-search-spot-result__left">
        <img
          src="@/assets/colorIcon/ai-search.svg"
        >
        Search results for <span class="ai-search-spot-result__hint">"<span class="ai-search-spot-result__keywords">{{ item.en }}</span>"</span>
      </div>
      <div class="ai-search-spot-result__right">
        View all
      </div>
    </div>
    <div class="ai-search-spot__content">
      <div
        class="ai-search-spot-thumbnail"
        v-for="product of item.product_list.slice(0, 4)"
        :key="product.offer_id"
      >
        <Image :src="product.image_url" />
        <div
          class="ai-search-spot-thumbnail__hot"
          v-if="product.month_sold"
        >
          <img
            class="ai-search-spot-thumbnail__fire"
            src="@/assets/hot.svg"
          >
          {{ formatSalesVolume(product.month_sold) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { openURLWithChannelQuery, formatSalesVolume } from '@/utils/utils'
import { Image } from '@/components/Image'

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const onSearchItemClick = (item) => {
  openURLWithChannelQuery(`/search?keyword=${props.item.en}&keywordCn=${props.item.cn}&isAISearched=true`)
}
</script>

<style lang="less" scoped>
.ai-search-spot {
  grid-column: span 4;
  padding: 16px 16px 10px;
  border: 1px solid #EBF1F5;
  border-radius: 8px;
  cursor: pointer;

  &__header {
    display: flex;
    align-items: center;
  }

  &__logo {
    width: 28px;
    height: 28px;
  }

  &__title {
    padding-top: 3px;
    font-family: mon-700;
    font-size: 20px;
  }

  &__subTitle {
    margin-top: 4px;
    font-family: mon-500;
    font-size: 12px;
    color: #6E717A;
  }

  &-result {
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__left, &__right {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    &__left {
      font-family: mon-500;
      font-size: 16px;
      color: #5C5C5C;

      > img {
        width: 16px;
        height: 16px;
      }
    }

    &__arrow {
      font-size: 16px;
    }

    &__hint {
      font-family: mon-700;
      font-size: 16px;
      color: #232323;
    }

    &__keywords {
      text-decoration: underline;
    }

    &__right {
      font-family: mon-500;
      font-size: 14px;
      text-decoration: underline;

      &:hover {
        color: var(--link-hover-color);
      }
    }
  }

  &__content {
    margin-top: 27px;
    display: flex;
    gap: 10px;
  }

  &-thumbnail {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    width: 100%;

    > img {
      display: block;
      width: 100%;
      aspect-ratio: 1;
      transition: all .2s ease-in-out;

      &:hover {
        transform: scale(1.2);
      }
    }

    &__hot {
      position: absolute;
      right: 8px;
      bottom: 8px;
      display: flex;
      align-items: center;
      gap: 2px;
      padding: 2px 8px 2px 4px;
      backdrop-filter: blur(20px);
      background: rgba(255, 255, 255, 0.8);
      border-radius: 8px;
      font-family: mon-500;
      font-size: 10px;

      > img {
        width: 12px;
        height: 12px;
      }
    }
  }
}
</style>
